<template>
  <div>
    <h5>Adding users for customers</h5>
    <form v-on:submit.prevent="addUsersForCustomers">
      <div class="form-group">
        <p>Korisnik iz firme :</p>
        <dropdownlist
          id="dropdownList"
          :data-items="getClients"
          :text-field="'companyName'"
          :data-item-key="'companyRegistrationId'"
          :filterable="true"
          @filterchange="filterChange"
          @change="onChange"
          :default-item="defaultItem"
        ></dropdownlist>
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Ime i prezime</label>
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Ime i prezime"
          v-model="firstLastName"
        />
      </div>
      <div class="form-group">
        <label for="inputEmail">Email</label>
        <input
          type="email"
          class="form-control"
          id="inputEmail"
          placeholder="Email"
          v-model="email"
        />
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Broj telefona</label>
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="06x/xxx-xxx"
          v-model="phoneNumber"
        />
      </div>

      <button type="submit" class="btn btn-primary">Dodaj korisnika</button>
    </form>
  </div>
</template>
<script>
/*eslint-disable */
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
const textField = "companyName";
const keyField = "companyRegistrationId";
const defaultItem = { [textField]: "Select customer...", [keyField]: null };
const emptyItem = { [textField]: "loading ..." };

export default {
  components: {
    dropdownlist: DropDownList
  },
  data() {
    return {
      firstLastName: "",
      phoneNumber: "",
      clientObj: {},
      defaultItem: defaultItem,
      emptyItem: emptyItem,
      email: ""
    };
  },
  computed: {
    getClients() {
      return this.$store.getters.getClients;
    },
    getSafeClients() {
      return this.$store.getters.getSafeClients;
    }
  },
  methods: {
    addUsersForCustomers() {
      const newUser = {
        firstAndLastName: this.firstLastName,
        phoneNumber: this.phoneNumber,
        email: this.email,
        client: this.clientObj
      };
      console.log(newUser);
      this.$store.dispatch("addUsersToCustomer", newUser);
    },
    filterChange(event) {
      var array = this.getClients.splice();
      array = this.filterData(event.filter);
      this.$store.commit("setClients", array);
    },
    filterData(filter) {
      if (filter.value.length <= 1)
        this.$store.commit("setClients", this.getSafeClients);
      const data = this.getClients.slice();
      return filterBy(data, filter);
    },

    onChange(event) {
      const value = event.value;
      if (value && value[textField] === emptyItem[textField]) {
        return;
      }
      this.clientObj = value;
      this.$store.commit("setClients", this.getSafeClients);
    }
  }
};
</script>
<style></style>
